import { AppMenu } from "../models/app/appMenu.model";
import { Injectable } from "@angular/core";
import { UserLogged } from "../models/data/userLogged.model";
import { TeiasoftSpeechRecognition } from "../models/app/teiasoftSpeechRecognition.model";
import { UserConfiguration } from "../models/data/userConfiguration.model";
import { Subject } from "rxjs";

export class PropertyDetail{
  showInfo?: boolean;
  infoText?: string;
  showFooter?: boolean;
}

@Injectable()
export class Globals{
  isDesktop?: boolean;
  appVersion?: string;
  clientLat?: number;
  clientLong?: number;
  clientCity?: string;
  clientZipCode?: string;
  permissionLocation?: boolean;
  propertyDetail?: PropertyDetail;
  activePage?:string;
  appMenu?: AppMenu[];
  cntPageH?:number;
  userLogged?: UserLogged;
  teiasoftSpeechRecognition?: TeiasoftSpeechRecognition; 
  theme?:string;
  dateFormat?:string;
  dateTimeFormat?:string;
  showNoData?: boolean;
  isMock?: boolean;
  apiUrl?:string;
  inputHasEvents?: boolean;
  discardEditInPlace = new Subject<number>();
  applyEditInPlace = new Subject<number>();
  discardItems = new Subject<number>();
}